import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';

import * as hooks from '../../auth/routerHooks';
import BarbersWrapper from './barbersWrapper/barbersWrapper';
import ShopBarbers from './barbersList/ShopBarbersListContainer';
import BrandBarbers from './barbersList/BrandBarbersListContainer';
import UnconfirmedBarbers from './UnconfirmedBarbers';
import DeletedBarbers from './deletedBarbersList/DeletedBarbersListContainer';
import ChairRentalList from './chairRental/containers/ChairRentalList';
import AddBarber from './addBarber/addBarber';
import BrandBarber from './containers/BrandBarber';
import BarberLayout from './components/BarberLayout';
import BarberDetails from './editDetailsBarber/editDetailsBarber';
import BarberWaitingList from '../waitingList/containers/BarberWaitingList';
import EditTimeTracking from '../timeTracker/containers/EditTimeTracking';

const ShopRoutes = store => (
  <Route path="/barbers" name="barbers">
    <Route
      component={BarbersWrapper}
      onEnter={hooks.requireBarberViewPermission(store)}
    >
      <IndexRoute component={ShopBarbers} />
      <Route
        path="unconfirmed"
        name="barbers.unconfirmed"
        component={UnconfirmedBarbers}
      />
      <Route
        path="chair-rental"
        name="barbers.chair-rental"
        onEnter={hooks.requireEnabledBoothRental(store)}
        component={ChairRentalList}
      />
    </Route>
    <Route
      path="add"
      name="barbers.add"
      component={AddBarber}
      onEnter={hooks.requireBarberModifyPermission(store)}
    />
    <Route
      path=":barberId"
      component={BarberLayout}
    >
      <IndexRoute
        component={BarberDetails}
        name="barbers.details"
        onEnter={hooks.requireBarberViewPermission(store)}
      />
      <Route path="waiting-list" component={BarberWaitingList} />
      <Route path="time-tracking" component={EditTimeTracking} />
    </Route>
  </Route>
);

const BarberRoutes = () => (
  <Route path="profile" component={BarberLayout}>
    <IndexRoute name="barbers.details" component={BarberDetails} />
    <Route path="waiting-list" component={BarberWaitingList} />
  </Route>
);

const BrandRoutes = store => (
  <Route path="barbers" name="barbers">
    <Route
      component={BarbersWrapper}
      onEnter={hooks.requireBarberViewPermission(store)}
    >
      <IndexRoute component={BrandBarbers} />
      <Route
        path="deleted"
        name="barbers.deleted"
        component={DeletedBarbers}
      />
    </Route>
    <Route
      path="add"
      name="barbers.add"
      component={BrandBarber}
      onEnter={hooks.requireBarberModifyPermission(store)}
    />
    <Route
      path=":barberId"
      name="barbers.details"
      onEnter={hooks.requireBarberViewPermission(store)}
      component={BrandBarber}
    />
  </Route>
);

export default {
  ShopRoutes,
  BarberRoutes,
  BrandRoutes,
};
